var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-wrapper"},_vm._l((_vm.data),function(block,index){return _c('media-block',{key:'media' + index,attrs:{"data":block,"columnClasses":_vm.columnClasses,"isReady":_vm.ready},on:{"heightChange":_vm.heightChange}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }